import { render, staticRenderFns } from "./NavigationGuard.vue?vue&type=template&id=494b7a89&scoped=true"
import script from "./NavigationGuard.vue?vue&type=script&lang=ts"
export * from "./NavigationGuard.vue?vue&type=script&lang=ts"
import style0 from "./NavigationGuard.vue?vue&type=style&index=0&id=494b7a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b7a89",
  null
  
)

export default component.exports